export function Juris(key){
    let data = localStorage.getItem("Authority")
    let arr = data.split(",")
    let index = arr.indexOf(key)
    if(arr.indexOf(key) > -1){
        return true
    }else{
        return false
    }
}